// Generated by purs version 0.13.8
"use strict";
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Control_MonadZero = require("../Control.MonadZero/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Filterable = require("../Data.Filterable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Lens_Fold = require("../Data.Lens.Fold/index.js");
var Data_Lens_Internal_Forget = require("../Data.Lens.Internal.Forget/index.js");
var Data_Lens_Record = require("../Data.Lens.Record/index.js");
var Data_Lens_Setter = require("../Data.Lens.Setter/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Maybe_First = require("../Data.Maybe.First/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Profunctor_Strong = require("../Data.Profunctor.Strong/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Lunarbox_Capability_Navigate = require("../Lunarbox.Capability.Navigate/index.js");
var Lunarbox_Capability_Resource_Project = require("../Lunarbox.Capability.Resource.Project/index.js");
var Lunarbox_Capability_Resource_Tutorial = require("../Lunarbox.Capability.Resource.Tutorial/index.js");
var Lunarbox_Component_HOC_Connect = require("../Lunarbox.Component.HOC.Connect/index.js");
var Lunarbox_Component_Icon = require("../Lunarbox.Component.Icon/index.js");
var Lunarbox_Component_Loading = require("../Lunarbox.Component.Loading/index.js");
var Lunarbox_Component_Tabs = require("../Lunarbox.Component.Tabs/index.js");
var Lunarbox_Component_Tooltip = require("../Lunarbox.Component.Tooltip/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var Lunarbox_Component_WithLogo = require("../Lunarbox.Component.WithLogo/index.js");
var Lunarbox_Data_Editor_State = require("../Lunarbox.Data.Editor.State/index.js");
var Lunarbox_Data_Ord = require("../Lunarbox.Data.Ord/index.js");
var Lunarbox_Data_ProjectId = require("../Lunarbox.Data.ProjectId/index.js");
var Lunarbox_Data_Route = require("../Lunarbox.Data.Route/index.js");
var Lunarbox_Data_Tutorial = require("../Lunarbox.Data.Tutorial/index.js");
var Network_RemoteData = require("../Network.RemoteData/index.js");
var Record = require("../Record/index.js");
var Web_Event_Event = require("../Web.Event.Event/index.js");
var Web_UIEvent_MouseEvent = require("../Web.UIEvent.MouseEvent/index.js");
var PersonalProjects = (function () {
    function PersonalProjects() {

    };
    PersonalProjects.value = new PersonalProjects();
    return PersonalProjects;
})();
var Examples = (function () {
    function Examples() {

    };
    Examples.value = new Examples();
    return Examples;
})();
var Tutorials = (function () {
    function Tutorials() {

    };
    Tutorials.value = new Tutorials();
    return Tutorials;
})();
var Initialize = (function () {
    function Initialize() {

    };
    Initialize.value = new Initialize();
    return Initialize;
})();
var OpenProject = (function () {
    function OpenProject(value0) {
        this.value0 = value0;
    };
    OpenProject.create = function (value0) {
        return new OpenProject(value0);
    };
    return OpenProject;
})();
var DeleteProject = (function () {
    function DeleteProject(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    DeleteProject.create = function (value0) {
        return function (value1) {
            return new DeleteProject(value0, value1);
        };
    };
    return DeleteProject;
})();
var DeleteTutorial = (function () {
    function DeleteTutorial(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    DeleteTutorial.create = function (value0) {
        return function (value1) {
            return new DeleteTutorial(value0, value1);
        };
    };
    return DeleteTutorial;
})();
var EditTutorial$prime = (function () {
    function EditTutorial$prime(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    EditTutorial$prime.create = function (value0) {
        return function (value1) {
            return new EditTutorial$prime(value0, value1);
        };
    };
    return EditTutorial$prime;
})();
var StartTutorial = (function () {
    function StartTutorial(value0) {
        this.value0 = value0;
    };
    StartTutorial.create = function (value0) {
        return new StartTutorial(value0);
    };
    return StartTutorial;
})();
var CreateProject = (function () {
    function CreateProject() {

    };
    CreateProject.value = new CreateProject();
    return CreateProject;
})();
var CreateTutorial = (function () {
    function CreateTutorial() {

    };
    CreateTutorial.value = new CreateTutorial();
    return CreateTutorial;
})();
var CloneProject = (function () {
    function CloneProject(value0) {
        this.value0 = value0;
    };
    CloneProject.create = function (value0) {
        return new CloneProject(value0);
    };
    return CloneProject;
})();
var Search = (function () {
    function Search(value0) {
        this.value0 = value0;
    };
    Search.create = function (value0) {
        return new Search(value0);
    };
    return Search;
})();
var Navigate = (function () {
    function Navigate(value0) {
        this.value0 = value0;
    };
    Navigate.create = function (value0) {
        return new Navigate(value0);
    };
    return Navigate;
})();
var SetTab = (function () {
    function SetTab(value0) {
        this.value0 = value0;
    };
    SetTab.create = function (value0) {
        return new SetTab(value0);
    };
    return SetTab;
})();
var Receive = (function () {
    function Receive(value0) {
        this.value0 = value0;
    };
    Receive.create = function (value0) {
        return new Receive(value0);
    };
    return Receive;
})();
var showTab = new Data_Show.Show(function (v) {
    if (v instanceof PersonalProjects) {
        return "Projects";
    };
    if (v instanceof Examples) {
        return "Examples";
    };
    if (v instanceof Tutorials) {
        return "Tutorials";
    };
    throw new Error("Failed pattern match at Lunarbox.Component.Projects (line 54, column 1 - line 57, column 31): " + [ v.constructor.name ]);
});
var eqTab = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof PersonalProjects && y instanceof PersonalProjects) {
            return true;
        };
        if (x instanceof Examples && y instanceof Examples) {
            return true;
        };
        if (x instanceof Tutorials && y instanceof Tutorials) {
            return true;
        };
        return false;
    };
});
var _search = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "search";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var _projectList = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "projectList";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var component = function (dictMonadEffect) {
    return function (dictMonadAff) {
        return function (dictManageProjects) {
            return function (dictManageTutorials) {
                return function (dictMonadAsk) {
                    return function (dictNavigate) {
                        var withRemoteData = function (remoteData) {
                            return function (f) {
                                if (remoteData instanceof Network_RemoteData.NotAsked) {
                                    return Lunarbox_Component_Loading.loading;
                                };
                                if (remoteData instanceof Network_RemoteData.Loading) {
                                    return Lunarbox_Component_Loading.loading;
                                };
                                if (remoteData instanceof Network_RemoteData.Failure) {
                                    return Halogen_HTML_Core.text("error " + remoteData.value0);
                                };
                                if (remoteData instanceof Network_RemoteData.Success) {
                                    return f(remoteData.value0);
                                };
                                throw new Error("Failed pattern match at Lunarbox.Component.Projects (line 237, column 33 - line 241, column 31): " + [ remoteData.constructor.name ]);
                            };
                        };
                        var searchBar = function (search) {
                            return Halogen_HTML_Elements.input([ Halogen_HTML_Properties.value(search), Halogen_HTML_Properties.placeholder("Search"), Halogen_HTML_Events.onValueInput(function ($135) {
                                return Data_Maybe.Just.create(Search.create($135));
                            }), Lunarbox_Component_Utils.className("projects__search-bar") ]);
                        };
                        var renderProject = function (isExample) {
                            return function (v) {
                                return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("project"), Halogen_HTML_Events.onClick(Data_Function["const"](Data_Maybe.Just.create((function () {
                                    if (isExample) {
                                        return CloneProject.create;
                                    };
                                    return OpenProject.create;
                                })()(v.id)))) ])([ Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("project__name no-overflow") ])([ Halogen_HTML_Core.text(v.name) ]), Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("project__data") ])([ Lunarbox_Component_Tooltip.tooltip("This project has " + (Data_Show.show(Data_Show.showInt)(v.metadata.functionCount) + " functions"))(Lunarbox_Component_Tooltip.Bottom.value)(Halogen_HTML_Elements.div)([ Lunarbox_Component_Utils.className("project__data-item") ])([ Lunarbox_Component_Icon.icon("functions"), Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(v.metadata.functionCount)) ]), Lunarbox_Component_Tooltip.tooltip("This project has " + (Data_Show.show(Data_Show.showInt)(v.metadata.nodeCount) + " nodes"))(Lunarbox_Component_Tooltip.Bottom.value)(Halogen_HTML_Elements.div)([ Lunarbox_Component_Utils.className("project__data-item") ])([ Lunarbox_Component_Icon.icon("track_changes"), Halogen_HTML_Core.text(Data_Show.show(Data_Show.showInt)(v.metadata.nodeCount)) ]), Lunarbox_Component_Utils.whenElem(!isExample)(function (v1) {
                                    return Lunarbox_Component_Tooltip.tooltip("Delete this tutorial")(Lunarbox_Component_Tooltip.Bottom.value)(Halogen_HTML_Elements.button)([ Lunarbox_Component_Utils.className("project__data-icon project__data-icon--clickable"), Halogen_HTML_Events.onClick((function () {
                                        var $136 = DeleteProject.create(v.id);
                                        return function ($137) {
                                            return Data_Maybe.Just.create($136($137));
                                        };
                                    })()) ])([ Lunarbox_Component_Icon.icon("delete") ]);
                                }) ]) ]);
                            };
                        };
                        var renderProjectList = function (areExamples) {
                            return function (projects) {
                                return function (extraRows) {
                                    var list = Data_Functor.map(Data_Functor.functorArray)(renderProject(areExamples))(projects);
                                    return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("projects__list") ])(Data_Semigroup.append(Data_Semigroup.semigroupArray)(extraRows)(list));
                                };
                            };
                        };
                        var newProject = function (text) {
                            return function (a) {
                                return Lunarbox_Component_Tooltip.tooltip(text)(Lunarbox_Component_Tooltip.Top.value)(Halogen_HTML_Elements.div)([ Lunarbox_Component_Utils.className("project project--new"), Halogen_HTML_Events.onClick(Data_Function["const"](new Data_Maybe.Just(a))) ])([ Lunarbox_Component_Icon.icon("add") ]);
                            };
                        };
                        var projectsHtml = function (v) {
                            var go = function (v1) {
                                var projects = Lunarbox_Data_Ord.sortBySearch(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                                    return "name";
                                }))(Data_Ord.ordString))()(new Data_Symbol.IsSymbol(function () {
                                    return "metadata";
                                }))(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                                    return "nodeCount";
                                }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                                    return "functionCount";
                                }))(Data_Ord.ordInt))))()(new Data_Symbol.IsSymbol(function () {
                                    return "id";
                                }))(Lunarbox_Data_ProjectId.ordProjectID)))(function (v2) {
                                    return v2.name;
                                })(v.search)(v1.userProjects);
                                var createProject = newProject("Create a new project")(CreateProject.value);
                                return renderProjectList(false)(projects)([ createProject ]);
                            };
                            return withRemoteData(v.projectList)(go);
                        };
                        var tutorialsHtml = function (v) {
                            var go = function (v1) {
                                var mkItem = function (v2) {
                                    return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("project"), Halogen_HTML_Events.onClick(Data_Function["const"](Data_Maybe.Just.create(new StartTutorial(v2.id)))) ])([ Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("project__name no-overflow") ])([ Halogen_HTML_Core.text(v2.name) ]), Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("project__data") ])([ Lunarbox_Component_Utils.whenElem(v2.completed)(function (v3) {
                                        return Lunarbox_Component_Tooltip.tooltip("You completed this tutorial")(Lunarbox_Component_Tooltip.Bottom.value)(Halogen_HTML_Elements.div)([ Lunarbox_Component_Utils.className("project__data-icon") ])([ Lunarbox_Component_Icon.icon("verified") ]);
                                    }), Lunarbox_Component_Utils.whenElem(v2.own)(function (v3) {
                                        return Lunarbox_Component_Tooltip.tooltip("Edit this tutorial")(Lunarbox_Component_Tooltip.Bottom.value)(Halogen_HTML_Elements.button)([ Lunarbox_Component_Utils.className("project__data-icon project__data-icon--clickable"), Halogen_HTML_Events.onClick((function () {
                                            var $138 = EditTutorial$prime.create(v2.id);
                                            return function ($139) {
                                                return Data_Maybe.Just.create($138($139));
                                            };
                                        })()) ])([ Lunarbox_Component_Icon.icon("edit") ]);
                                    }), Lunarbox_Component_Utils.whenElem(v2.own)(function (v3) {
                                        return Lunarbox_Component_Tooltip.tooltip("Delete this tutorial")(Lunarbox_Component_Tooltip.Bottom.value)(Halogen_HTML_Elements.button)([ Lunarbox_Component_Utils.className("project__data-icon project__data-icon--clickable"), Halogen_HTML_Events.onClick((function () {
                                            var $140 = DeleteTutorial.create(v2.id);
                                            return function ($141) {
                                                return Data_Maybe.Just.create($140($141));
                                            };
                                        })()) ])([ Lunarbox_Component_Icon.icon("delete") ]);
                                    }) ]) ]);
                                };
                                return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("projects__list") ])(Data_Semigroup.append(Data_Semigroup.semigroupArray)([ Lunarbox_Component_Utils.whenElem(Data_Maybe.maybe(false)(function (v2) {
                                    return v2.isAdmin;
                                })(v.currentUser))(function (v2) {
                                    return newProject("Create a new tutorial")(CreateTutorial.value);
                                }) ])(Data_Functor.map(Data_Functor.functorArray)(mkItem)(v1.tutorials)));
                            };
                            return withRemoteData(v.projectList)(go);
                        };
                        var handleAction = function (v) {
                            if (v instanceof Receive) {
                                return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Record.merge()()(v.value0));
                            };
                            if (v instanceof Initialize) {
                                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Capability_Resource_Project.getProjects(Lunarbox_Capability_Resource_Project.manageUserHalogenM(dictManageProjects)))(function (projectList) {
                                    return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                        var $77 = {};
                                        for (var $78 in v1) {
                                            if ({}.hasOwnProperty.call(v1, $78)) {
                                                $77[$78] = v1[$78];
                                            };
                                        };
                                        $77.projectList = Network_RemoteData.fromEither(projectList);
                                        return $77;
                                    });
                                });
                            };
                            if (v instanceof Search) {
                                return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                    var $80 = {};
                                    for (var $81 in v1) {
                                        if ({}.hasOwnProperty.call(v1, $81)) {
                                            $80[$81] = v1[$81];
                                        };
                                    };
                                    $80.search = v.value0;
                                    return $80;
                                });
                            };
                            if (v instanceof Navigate) {
                                return Lunarbox_Capability_Navigate.navigate(Lunarbox_Capability_Navigate.navigateHalogenM(dictNavigate))(v.value0);
                            };
                            if (v instanceof OpenProject) {
                                return Lunarbox_Capability_Navigate.navigate(Lunarbox_Capability_Navigate.navigateHalogenM(dictNavigate))(new Lunarbox_Data_Route.Project(v.value0));
                            };
                            if (v instanceof SetTab) {
                                return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                    var $86 = {};
                                    for (var $87 in v1) {
                                        if ({}.hasOwnProperty.call(v1, $87)) {
                                            $86[$87] = v1[$87];
                                        };
                                    };
                                    $86.currentTab = v.value0;
                                    return $86;
                                });
                            };
                            if (v instanceof CloneProject) {
                                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Capability_Resource_Project.cloneProject(Lunarbox_Capability_Resource_Project.manageUserHalogenM(dictManageProjects))(v.value0))(function (response) {
                                    if (response instanceof Data_Either.Right) {
                                        return Lunarbox_Capability_Navigate.navigate(Lunarbox_Capability_Navigate.navigateHalogenM(dictNavigate))(new Lunarbox_Data_Route.Project(response.value0));
                                    };
                                    if (response instanceof Data_Either.Left) {
                                        return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                            var $92 = {};
                                            for (var $93 in v1) {
                                                if ({}.hasOwnProperty.call(v1, $93)) {
                                                    $92[$93] = v1[$93];
                                                };
                                            };
                                            $92.projectList = new Network_RemoteData.Failure(response.value0);
                                            return $92;
                                        });
                                    };
                                    throw new Error("Failed pattern match at Lunarbox.Component.Projects (line 137, column 7 - line 139, column 60): " + [ response.constructor.name ]);
                                });
                            };
                            if (v instanceof EditTutorial$prime) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Web_Event_Event.stopPropagation(Web_UIEvent_MouseEvent.toEvent(v.value1))))(function () {
                                    return Lunarbox_Capability_Navigate.navigate(Lunarbox_Capability_Navigate.navigateHalogenM(dictNavigate))(new Lunarbox_Data_Route.EditTutorial(v.value0));
                                });
                            };
                            if (v instanceof StartTutorial) {
                                return Lunarbox_Capability_Navigate.navigate(Lunarbox_Capability_Navigate.navigateHalogenM(dictNavigate))(new Lunarbox_Data_Route.Tutorial(v.value0));
                            };
                            if (v instanceof DeleteProject) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Web_Event_Event.stopPropagation(Web_UIEvent_MouseEvent.toEvent(v.value1))))(function () {
                                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Fold.preview((function () {
                                        var $142 = _projectList(Data_Lens_Internal_Forget.strongForget);
                                        var $143 = Network_RemoteData["_Success"](Data_Lens_Internal_Forget.choiceForget(Data_Maybe_First.monoidFirst));
                                        return function ($144) {
                                            return $142($143($144));
                                        };
                                    })())))(function (oldProjects) {
                                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(_projectList(Data_Profunctor_Strong.strongFn))(Network_RemoteData.Loading.value)))(function () {
                                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Capability_Resource_Project.deleteProject(Lunarbox_Capability_Resource_Project.manageUserHalogenM(dictManageProjects))(v.value0))(function (response) {
                                                if (response instanceof Data_Either.Right) {
                                                    return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(_projectList(Data_Profunctor_Strong.strongFn))((function () {
                                                        if (oldProjects instanceof Data_Maybe.Just) {
                                                            return Network_RemoteData.Success.create({
                                                                userProjects: Data_Filterable.filter(Data_Filterable.filterableArray)(function ($145) {
                                                                    return (function (v2) {
                                                                        return Data_Eq.notEq(Lunarbox_Data_ProjectId.eqProjectId)(v2)(v.value0);
                                                                    })((function (v2) {
                                                                        return v2.id;
                                                                    })($145));
                                                                })(oldProjects.value0.userProjects),
                                                                exampleProjects: oldProjects.value0.exampleProjects,
                                                                tutorials: oldProjects.value0.tutorials
                                                            });
                                                        };
                                                        if (oldProjects instanceof Data_Maybe.Nothing) {
                                                            return new Network_RemoteData.Failure("Cannot find projec list");
                                                        };
                                                        throw new Error("Failed pattern match at Lunarbox.Component.Projects (line 154, column 15 - line 159, column 61): " + [ oldProjects.constructor.name ]);
                                                    })()));
                                                };
                                                if (response instanceof Data_Either.Left) {
                                                    return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(_projectList(Data_Profunctor_Strong.strongFn))(new Network_RemoteData.Failure(response.value0)));
                                                };
                                                throw new Error("Failed pattern match at Lunarbox.Component.Projects (line 150, column 7 - line 160, column 61): " + [ response.constructor.name ]);
                                            });
                                        });
                                    });
                                });
                            };
                            if (v instanceof DeleteTutorial) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Web_Event_Event.stopPropagation(Web_UIEvent_MouseEvent.toEvent(v.value1))))(function () {
                                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Fold.preview((function () {
                                        var $146 = _projectList(Data_Lens_Internal_Forget.strongForget);
                                        var $147 = Network_RemoteData["_Success"](Data_Lens_Internal_Forget.choiceForget(Data_Maybe_First.monoidFirst));
                                        return function ($148) {
                                            return $146($147($148));
                                        };
                                    })())))(function (oldProjects) {
                                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(_projectList(Data_Profunctor_Strong.strongFn))(Network_RemoteData.Loading.value)))(function () {
                                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Capability_Resource_Tutorial.deleteTutorial(Lunarbox_Capability_Resource_Tutorial.manageTutorialsHalogenM(dictManageTutorials))(v.value0))(function (v1) {
                                                if (v1 instanceof Data_Either.Right) {
                                                    var newProjectList = (function () {
                                                        if (oldProjects instanceof Data_Maybe.Just) {
                                                            return Network_RemoteData.Success.create({
                                                                tutorials: Data_Filterable.filter(Data_Filterable.filterableArray)(function ($149) {
                                                                    return (function (v3) {
                                                                        return Data_Eq.notEq(Lunarbox_Data_Tutorial.eqTutorialId)(v3)(v.value0);
                                                                    })((function (v3) {
                                                                        return v3.id;
                                                                    })($149));
                                                                })(oldProjects.value0.tutorials),
                                                                exampleProjects: oldProjects.value0.exampleProjects,
                                                                userProjects: oldProjects.value0.userProjects
                                                            });
                                                        };
                                                        if (oldProjects instanceof Data_Maybe.Nothing) {
                                                            return new Network_RemoteData.Failure("Cannot find old project list");
                                                        };
                                                        throw new Error("Failed pattern match at Lunarbox.Component.Projects (line 169, column 32 - line 177, column 66): " + [ oldProjects.constructor.name ]);
                                                    })();
                                                    return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(_projectList(Data_Profunctor_Strong.strongFn))(newProjectList));
                                                };
                                                if (v1 instanceof Data_Either.Left) {
                                                    return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(_projectList(Data_Profunctor_Strong.strongFn))(new Network_RemoteData.Failure(v1.value0)));
                                                };
                                                throw new Error("Failed pattern match at Lunarbox.Component.Projects (line 166, column 13 - line 178, column 65): " + [ v1.constructor.name ]);
                                            });
                                        });
                                    });
                                });
                            };
                            if (v instanceof CreateProject) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(_projectList(Data_Profunctor_Strong.strongFn))(Network_RemoteData.Loading.value)))(function () {
                                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Data_Editor_State.emptyState(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0())))(function (state) {
                                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Capability_Resource_Project.createProject(Lunarbox_Capability_Resource_Project.manageUserHalogenM(dictManageProjects))(state))(function (response) {
                                            if (response instanceof Data_Either.Right) {
                                                return Lunarbox_Capability_Navigate.navigate(Lunarbox_Capability_Navigate.navigateHalogenM(dictNavigate))(new Lunarbox_Data_Route.Project(response.value0));
                                            };
                                            if (response instanceof Data_Either.Left) {
                                                return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(_projectList(Data_Profunctor_Strong.strongFn))(new Network_RemoteData.Failure(response.value0)));
                                            };
                                            throw new Error("Failed pattern match at Lunarbox.Component.Projects (line 184, column 7 - line 186, column 61): " + [ response.constructor.name ]);
                                        });
                                    });
                                });
                            };
                            if (v instanceof CreateTutorial) {
                                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                    return v1.projectList;
                                }))(function (projectList) {
                                    var v1 = Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(Data_Array.head)(Data_Functor.map(Data_Maybe.functorMaybe)(function (v2) {
                                        return v2.userProjects;
                                    })(Network_RemoteData.toMaybe(projectList)));
                                    if (v1 instanceof Data_Maybe.Just) {
                                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(_projectList(Data_Profunctor_Strong.strongFn))(Network_RemoteData.Loading.value)))(function () {
                                            return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Capability_Resource_Tutorial.createTutorial(Lunarbox_Capability_Resource_Tutorial.manageTutorialsHalogenM(dictManageTutorials))({
                                                base: v1.value0.id,
                                                solution: v1.value0.id
                                            }))(function (response) {
                                                if (response instanceof Data_Either.Right) {
                                                    return Lunarbox_Capability_Navigate.navigate(Lunarbox_Capability_Navigate.navigateHalogenM(dictNavigate))(new Lunarbox_Data_Route.EditTutorial(response.value0));
                                                };
                                                if (response instanceof Data_Either.Left) {
                                                    return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(_projectList(Data_Profunctor_Strong.strongFn))(new Network_RemoteData.Failure(response.value0)));
                                                };
                                                throw new Error("Failed pattern match at Lunarbox.Component.Projects (line 193, column 11 - line 195, column 65): " + [ response.constructor.name ]);
                                            });
                                        });
                                    };
                                    if (v1 instanceof Data_Maybe.Nothing) {
                                        return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(_projectList(Data_Profunctor_Strong.strongFn))(new Network_RemoteData.Failure("You have no projects which can be used as a solution/base for this tutorial!")));
                                    };
                                    throw new Error("Failed pattern match at Lunarbox.Component.Projects (line 189, column 7 - line 196, column 135): " + [ v1.constructor.name ]);
                                });
                            };
                            throw new Error("Failed pattern match at Lunarbox.Component.Projects (line 125, column 18 - line 196, column 135): " + [ v.constructor.name ]);
                        };
                        var goBack = Halogen_HTML_Elements.div([ Halogen_HTML_Events.onClick(Data_Function["const"](Data_Maybe.Just.create(new Navigate(Lunarbox_Data_Route.Home.value)))), Lunarbox_Component_Utils.className("projects__back") ])([ Lunarbox_Component_Icon.icon("arrow_back_ios") ]);
                        var examplesHtml = function (v) {
                            var go = function (v1) {
                                var projects = Lunarbox_Data_Ord.sortBySearch(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                                    return "name";
                                }))(Data_Ord.ordString))()(new Data_Symbol.IsSymbol(function () {
                                    return "metadata";
                                }))(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                                    return "nodeCount";
                                }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
                                    return "functionCount";
                                }))(Data_Ord.ordInt))))()(new Data_Symbol.IsSymbol(function () {
                                    return "id";
                                }))(Lunarbox_Data_ProjectId.ordProjectID)))(function (v2) {
                                    return v2.name;
                                })(v.search)(v1.exampleProjects);
                                return renderProjectList(true)(projects)([  ]);
                            };
                            return withRemoteData(v.projectList)(go);
                        };
                        var examplesExist = function (v) {
                            if (v instanceof Network_RemoteData.Success) {
                                return !Data_Array["null"](v.value0.exampleProjects);
                            };
                            return true;
                        };
                        var render = function (v) {
                            var examplesTab = Control_Bind.discard(Control_Bind.discardUnit)(Control_Bind.bindArray)(Control_MonadZero.guard(Control_MonadZero.monadZeroArray)(examplesExist(v.projectList)))(function () {
                                return [ {
                                    name: Examples.value,
                                    content: examplesHtml(v)
                                } ];
                            });
                            return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("projects") ])([ Lunarbox_Component_WithLogo.withLogo(Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("projects__container") ])([ Lunarbox_Component_Tabs.component(showTab)(eqTab)({
                                currentTab: v.currentTab,
                                headerStart: new Data_Maybe.Just(goBack),
                                headerEnd: Data_Maybe.Just.create(searchBar(v.search)),
                                setTab: function ($150) {
                                    return Data_Maybe.Just.create(SetTab.create($150));
                                },
                                tabs: Data_Semigroup.append(Data_Semigroup.semigroupArray)([ {
                                    name: PersonalProjects.value,
                                    content: projectsHtml(v)
                                } ])(Data_Semigroup.append(Data_Semigroup.semigroupArray)(examplesTab)([ {
                                    name: Tutorials.value,
                                    content: tutorialsHtml(v)
                                } ]))
                            }) ])) ]);
                        };
                        return Lunarbox_Component_HOC_Connect.component(dictMonadAff)(dictMonadAsk)()(Halogen_Component.mkComponent({
                            initialState: Data_Function["const"]({
                                projectList: Network_RemoteData.NotAsked.value,
                                search: "",
                                currentTab: PersonalProjects.value,
                                currentUser: Data_Maybe.Nothing.value
                            }),
                            render: render,
                            "eval": Halogen_Component.mkEval({
                                handleAction: handleAction,
                                handleQuery: Halogen_Component.defaultEval.handleQuery,
                                receive: function ($151) {
                                    return Data_Maybe.Just.create(Receive.create($151));
                                },
                                initialize: new Data_Maybe.Just(Initialize.value),
                                finalize: Halogen_Component.defaultEval.finalize
                            })
                        }));
                    };
                };
            };
        };
    };
};
module.exports = {
    component: component
};
